/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the field to use for grouping the data:
 *   * DATE : the date (truncated on day)
 *   * TAG : the tag name
 *   * DESCRIPTION : the tag description
 *   * VALUE : the value
 *   * GROUP : the tag group
 */
export enum EventLogGroupName {
  DATE = 'DATE',
  TAG = 'TAG',
  DESCRIPTION = 'DESCRIPTION',
  VALUE = 'VALUE',
  GROUP = 'GROUP'
}
